/**
 * NCC: <ncc-club-dispatch> - on a Cheese Box Club product page, while the club runs one dispatch day a month (Theme
 * settings > Delivery dates > Cheese Box Club dispatch = fixed), the sentence under the plan choice with the real
 * dates: "Boxes are delivered on the third Wednesday of every month. Order by 10 October and your first box
 * arrives on Wednesday 21 October." ([dispatch_day], [order_by] and [date] in the setting's text). The same rules as the bag (assets/ncc-delivery-dates.js firstDispatch), worked out
 * for today's UK date; the server renders the undated sentence ("... on the third Wednesday of each month") for
 * the moment before this runs, and a tab left open is brought up to date when it is shown again.
 */
import { buildDispatchRules, fillDispatchText, firstDispatch, today } from '@theme/ncc-delivery-dates';

class ClubDispatch extends HTMLElement {
  connectedCallback() {
    this.#render();
    document.addEventListener('visibilitychange', this.#onVisible);
  }

  disconnectedCallback() {
    document.removeEventListener('visibilitychange', this.#onVisible);
  }

  #onVisible = () => {
    if (document.visibilityState === 'visible') this.#render();
  };

  #render() {
    const d = this.dataset;
    const rules = buildDispatchRules({ week: d.week, weekday: d.weekday, orderByDay: d.orderBy });
    const dispatch = firstDispatch(today(new Date(), d.timezone || 'Europe/London'), rules);
    if (!dispatch.date) return;
    const template = d.text || 'Boxes are delivered on the [dispatch_day] of every month. Order by [order_by] and your first box arrives on [date].';
    const text = fillDispatchText(template, dispatch, rules);
    const target = this.querySelector('[data-ref="text"]');
    if (target && target.textContent !== text) target.textContent = text;
  }
}

if (!customElements.get('ncc-club-dispatch')) customElements.define('ncc-club-dispatch', ClubDispatch);
